import { render, staticRenderFns } from "./ResultadoEvaluacionSection.vue?vue&type=template&id=0f590201"
import script from "./ResultadoEvaluacionSection.vue?vue&type=script&lang=js"
export * from "./ResultadoEvaluacionSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports